// Module
var code = "LifestatusDesigner";
// Exports
export default code;